<template>
  <div>
    <NavBar />
    <div class="content-container">
      <div class="list-container">
        <!-- 搜索 -->
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <div class="search">
            <el-form-item label="产品名称">
              <el-select v-model="search.productId" placeholder="请选择" filterable>
                <el-option v-for="item in productList" :key="item.id" :label="item.NAME" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="投放状态">
              <el-select v-model="search.assignLauchStatus" placeholder="请选择">
                <el-option v-for="item in statuList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=""></el-form-item>
            <el-form-item style="text-align: right">
              <el-button type="primary" @click="queryData" style="margin-right:8px">搜索
              </el-button>
              <el-button @click="resetSearch">重置</el-button>
            </el-form-item>
          </div>
        </el-form>

        <!-- 投放数据 -->
        <!-- 数据列表 -->
        <el-table :key="tableKey" ref="multipleTable" v-loading="listLoading" stripe :data="list" tooltip-effect="dark"
          style="width: 100%" :height="tableHeight">
          <el-table-column label="序号" type="index" width="55">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="产品名称" min-width="100px">
            <template slot-scope="scope">
              {{
                  emptyDeal(scope.row.productName)
              }}
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="投放任务" min-width="100px">
            <template slot-scope="scope">
              {{
                  emptyDeal(scope.row.packageName)
              }}
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="投放日期" min-width="100px">
            <template slot-scope="scope">
              {{
                  scope.row.endTime
                    ? date(scope.row.startTime) + "至" + date(scope.row.endTime)
                    : date(scope.row.startTime) + "至今"
              }}
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="投放状态" min-width="100px">
            <template slot-scope="scope">
              {{
                  status(scope.row.assignLauchStatus).val
              }}
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="数据更新日期" min-width="100px">
            <template slot-scope="scope">
              {{
                  scope.row.lastUpdateTime ? date(scope.row.lastUpdateTime) : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" width="160px" label="操作">
            <template slot-scope="scope">
              <div class="icon-table-handle">
                <el-button type="text" @click="goDetail(scope.row)">
                  查看预估详情
                </el-button>
              </div>
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="查看预估详情"
                placement="top"
              >
                <i
                  class="iconfont"
                  @click="goDetail(scope.row)"
                >&#xe621;</i>

              </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="mt10">
          <el-pagination :key="pageInfo.currentPage" :current-page="pageInfo.currentPage" :page-size="pageInfo.limit"
            layout="total,sizes, prev, pager, next" :total="pageInfo.allCount" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
        <!-- 详情 -->
        <template>
          <div v-if="dialogDetail">
            <Detail :platform="platform" @close="handleClose" :data="detailData" :search="searchData"
              :showTotal="total" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/navBar";
import { launchList, estimateDetail, getProduct } from "@/api/launch";
import {
  emptyTrans,
  formatMoney,
  formatDate,
  statusTrans
} from "@/api/dataTrans.js";
import Detail from "./components/detail.vue";
import Setting from "@/settings.js";

var { pageConfig } = Setting;
export default {
  components: { Detail, NavBar },
  data() {
    return {
      search: {
        productId: null,
        assignLauchStatus: null
      },
      dialogDetail: false,
      productList: [],
      statuList: [
        { name: "投放中", id: 223 },
        { name: "投放结束", id: 226 }
      ],
      list: [],
      tableKey: 0,
      pageInfo: {
        limit: pageConfig["limit"],
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      tableHeight: document.body.clientHeight - 297,
      listLoading: false,
      detailData: {},
      searchData: {},
      total: {},
      platform: null, // 平台
    };
  },
  mounted() {
    this.getList();
    window.onresize = function () {
      this.tableHeight = document.body.clientHeight - 297;
    };
    getProduct().then(res => {
      if (res && res.code == 0) {
        this.productList = res.data;
      }
    });
  },
  methods: {
    date(_val) {
      return formatDate(_val);
    },
    status(val) {
      return statusTrans(val, this.statuList);
    },
    getList() {
      var pramaList = {};
      pramaList = this.search;
      launchList({
        pageNo: this.pageInfo.currentPage,
        pageSize: this.pageInfo.limit,
        ...pramaList
      }).then(res => {
        if (res && res.code == 0) {
          this.list = res.data.items;
          this.pageInfo.allCount = res.data.total;
        }
      });
    },
    queryData() {
      this.pageInfo.currentPage = 1;
      this.getList();
    },
    resetSearch(formName) {
      this.search = this.$options.data().search;
      this.getList();
    },
    goDetail(val) {
      this.searchData = val;
      this.platform = val.platform;
      this.getDetail(val);
    },
    getDetail(val) {
      estimateDetail({
        pageSize: 10,
        pageNo: 1,
        packageId: val.packageId,
        effectStartTime: formatDate(val.startTime),
        effectEndTime: formatDate(val.endTime)
      }).then(res => {
        if (res && res.code == 0) {
          this.detailData = res.data;
          this.total.currentData = this.$countCurrentPage(
            "trafficUserEstimateDataNums",
            res.data.items
          );
          this.total.currentMoney = this.$countCurrentPage(
            "siteEstimateMoney",
            res.data.items
          );
          this.dialogDetail = true;
        }
      });
    },
    // 显示隐藏操作按钮
    operateShow(row, column, cell, event) {
      event.path[1].cells[6].children[0].children[0].style.display = "block";
    },
    operateClose() {
      event.path[1].cells[6].children[0].children[0].style.display = "none";
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getList();
    },
    emptyDeal(_val) {
      return emptyTrans(_val);
    },
    handleClose() {
      this.dialogDetail = false;
      this.platform = null;
      this.getList();
    },
    moneyTrans(_val) {
      return formatMoney(_val);
    }
  }
};
</script>
<style scoped lang="scss">
/deep/ .el-form-item__label {
  text-align: left;
}

/deep/ .el-input {
  width: 100%;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-form-item {
  margin-bottom: 16px;
}

.icon {
  display: none;
  text-align: center;
}

/deep/ .el-form-item__label {
  text-align: right;
}

.iconfont {
  display: none;
}

/deep/ .el-form-item {
  width: 90%;
  margin-bottom: 22px;
}

.list-container {
  background-color: #fff;
  padding: 24px;
  min-height: 860px;
}
</style>
